export default {
  isOneAmountData: {
    // 商品选择器 - 单选并且录入数量 - 默认不开启
    type: Boolean,
    default: false,
  },
  rowData: {
    // 当前按钮点击的行数据
    type: Object,
    default: () => ({}),
  },
  // 通过【添加商品】按钮添加明细时触发反算的工具类（为null时不触发反算）
  useBackCountAddItems: {
    type: String,
    default: 'orderBackCountUtil',
  },
  buttonMenuListUrl: {
    type: String,
    default: '',
  },
  value: {
    type: [String, Object, Array],
    default: null,
  },
  store: {
    type: Object,
    default: () => ({}),
  },
  //弹出框的宽度
  width: {
    type: [String, Number],
    default: 1200,
  },
  //弹出框的标题
  title: {
    type: String,
    default: '商品选择器',
  },
  bodyBgc: {
    type: Boolean,
    default: true,
  },
  maskClosable: {
    type: Boolean,
    default: true,
  },
  //是否置于顶层
  transfer: {
    type: Boolean,
    default: true,
  },
  //表格是否显示多选
  selection: {
    type: Boolean,
    default: false,
  },
  //是否显示弹出
  isShowModal: {
    type: Boolean,
    default: false,
  },
  //分类
  typeList: {
    type: Array,
    default: () => [
      {
        name: '自定义分类',
        code: 'CUSTOM_CATALOG_ONE',
      },
      {
        name: '自定义分类2',
        code: 'CUSTOM_CATALOG_TWO',
      },
      {
        name: '自定义分类3',
        code: 'CUSTOM_CATALOG_THREE',
      },
    ],
  },
  //默认选中的分类
  propsType: {
    type: Object,
    default: () => ({
      name: '自定义分类',
      code: 'CUSTOM_CATALOG_ONE',
    }),
  },
  //分类请求的接口
  treeUrl: {
    type: String,
    default: '',
  },
  //请求方法
  treeMethod: {
    type: String,
    default: 'get',
  },
  treeParams: {
    type: Object,
    default: () => ({}),
  },
  //表格的定义
  tableColumnDefUrl: {
    type: String,
    default: '', // ~static/rest/main/dict/getTableByCode?tableCode=
  },
  showAllExpandBtn: {
    // 是否显示  全部展开按钮
    type: Boolean,
    default: true,
  },
  // 查询表单表单定义配置Url
  searchUrlItemsDef: {
    type: String,
    default: '',
  },

  //表格请求数据
  tableDataUrlQuery: {
    type: String,
    require: true,
    default: '',
  },
  // 表格查询-参数
  tableDataUrlQueryParamter: {
    type: Object,
    default: () => ({}),
  },
  // 查询table请求方式
  tableDataUrlQueryMethod: {
    type: String,
    default: 'get',
  },
  //是否显示多选按钮组
  isShowFooterBtn: {
    type: Boolean,
    default: true,
  },
  //底部按钮名称
  sureAndContinue: {
    type: String,
    default: '提交并继续',
  },
  //底部按钮名称
  sureAndClose: {
    type: String,
    default: '提交并关闭',
  },
  //底部按钮名称
  sureAndContinueForAmount: {
    type: String,
    default: '提交并继续',
  },
  //底部按钮名称
  sureAndCloseForAmount: {
    type: String,
    default: '提交并关闭',
  },
  //底部按钮名称
  sureText: {
    type: String,
    default: '确定',
  },

  //是否显示合计
  isShowSummary: {
    type: Boolean,
    default: false,
  },
  //是否显示表格行级操作
  menuShow: {
    type: Boolean,
    default: true,
  },
  // 请求 createOrderItem 接口的地址
  createItemOfUrl: {
    type: String,
    default: '',
  },
  // 请求 createOrderItem 接口的参数
  createItemOfParams: {
    type: Object,
  },
  //是否是商品选择器
  isGoodSelct: {
    type: Boolean,
    default: false,
  },
}
